import type { ReactNode } from 'react'
import { useState } from 'react'

import en from './langs/en.json'

export type Translations = typeof en

export const getDefaultMessages = (): Translations => en

export const useLocalization = () => {
  const storedLang = localStorage.getItem('lang')
  const [lang] = useState(storedLang ?? 'en')
  // English-only for now; when i18n is needed, resolve messages from `lang`
  // (a real async load then belongs in a route loader, not a mirror effect).
  const messages = getDefaultMessages()

  return { lang, messages }
}

export const defaultRichTextElements = {
  br: () => <br />,
  hr: () => <hr />,
  ul: (...chunks: ReactNode[]) => <ul>{chunks}</ul>,
  li: (...chunks: ReactNode[]) => <li>{chunks}</li>,
  a: (...chunks: ReactNode[]) => <a>{chunks}</a>,
  b: (...chunks: ReactNode[]) => <b>{chunks}</b>,
  i: (...chunks: ReactNode[]) => <i>{chunks}</i>,
  span: (...chunks: ReactNode[]) => <span>{chunks}</span>,
  p: (...chunks: ReactNode[]) => <p>{chunks}</p>,
  div: (...chunks: ReactNode[]) => <div>{chunks}</div>,
}
